import './collapsibleSeoContent.css';

function CollapsibleSeoContent({ buttonLabel, title, intro, sections = [], faq = [] }) {
  if (!title) return null;

  const faqHeadingId = 'seo-content-faq-heading';
  const titleId = 'seo-content-title';

  return (
    <section className="seo-content-wrap container" aria-label="Additional information">
      <details className="seo-content-details">
        <summary className="btn btn-ghost seo-content-trigger">{buttonLabel || 'Learn More'}</summary>
        <article
          className="seo-content-panel card"
          role="region"
          aria-labelledby={titleId}
        >
          <h2 id={titleId} className="seo-content-title">
            {title}
          </h2>
          {intro ? <p className="seo-content-intro">{intro}</p> : null}

          {sections.map((section) => (
            <section key={section.heading} className="seo-content-section">
              <h3 className="seo-content-section-heading">{section.heading}</h3>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph.slice(0, 48)} className="seo-content-text">
                  {paragraph}
                </p>
              ))}
              {section.list?.length ? (
                <ul className="seo-content-list">
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
            </section>
          ))}

          {faq.length > 0 ? (
            <section className="seo-content-faq" aria-labelledby={faqHeadingId}>
              <h3 id={faqHeadingId} className="seo-content-section-heading">
                Frequently Asked Questions
              </h3>
              {faq.map((item) => (
                <div key={item.q} className="seo-content-faq-item">
                  <h4 className="seo-content-faq-question">{item.q}</h4>
                  <p className="seo-content-text">{item.a}</p>
                </div>
              ))}
            </section>
          ) : null}
        </article>
      </details>
    </section>
  );
}

export default CollapsibleSeoContent;
